export enum CustomRouteFormTemplateComponentErrorMessages {
    MESSAGE_ROUTES = 'not_valid_routes',
    MESSAGE_TRAVEL_OBJECTIVE = 'not_valid_selected_objective',
    MESSAGE_SELECTED_PREDEFINED_OPTION = 'not_valid_travel_frequency',
    MESSAGE_DISTANCE = 'not_calculated_distance',
    MESSAGE_DURATION = 'not_calculated_duration',
    MESSAGE_CUSTOM_ROUTE_FORM = 'not_valid_custom_route_form',
    MESSAGE_DONT_LEAVE_EMPTY_INPUTS = "dont_leave_empty_address_fields",
    MESSAGE_SELECTED_VEHICLE = "please_select_vehicle",






}